import React from 'react'

function OnlineIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      fill="none"
      viewBox="0 0 33 32"
    >
      <path
        fill="#2E86BD"
        d="M16.501 2.668c-7.36 0-13.333 5.973-13.333 13.333s5.973 13.334 13.333 13.334S29.835 23.36 29.835 16c0-7.36-5.974-13.333-13.334-13.333zm-2.666 20l-6.667-6.667 1.88-1.88 4.787 4.774 10.12-10.12 1.88 1.893-12 12z"
      />
    </svg>
  )
}

export default OnlineIcon
